import React from "react";
const Footer = (props) => {
  const sendNavLinks = (id) => {
    props.navLink(id);
  };
  return (
    <footer>
      <div className="footer bg-footer section border-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-8 mb-5 mb-lg-0">
              <a className="logo-footer" href="index.html">
                <img
                  className="img-fluid mb-4"
                  src="images/slpLogo.jpg"
                  alt="logo"
                />
              </a>
            </div>
            <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-5 mb-md-0">
              <h4 className="text-white mb-5">COMPANY</h4>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <div
                    className="text-color"
                    onClick={() => sendNavLinks("about")}
                  >
                    About Us
                  </div>
                </li>
                <li className="mb-3">
                  <div
                    className="text-color"
                    onClick={() => sendNavLinks("team")}
                  >
                    Our Team
                  </div>
                </li>
                <li className="mb-3">
                  <div
                    className="text-color"
                    onClick={() => sendNavLinks("contact")}
                  >
                    Contact
                  </div>
                </li>
                
              </ul>
            </div>
            
            {/* <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-5 mb-md-0">
              <h4 className="text-white mb-5">EXPERTIES</h4>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <a
                    className="text-color"
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.upwork.com/freelancers/haroonrasheed136"
                  >
                    React
                  </a>
                </li>
                <li className="mb-3">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    className="text-color"
                    href="https://www.upwork.com/freelancers/haroonrasheed136"
                  >
                    Angular
                  </a>
                </li>
                <li className="mb-3">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    className="text-color"
                    href="https://www.upwork.com/freelancers/haroonrasheed136"
                  >
                    Dot Net Core
                  </a>
                </li>
                <li className="mb-3">
                  <a
                    rel="noreferrer"
                    target="_blank"
                    className="text-color"
                    href="https://www.upwork.com/freelancers/haroonrasheed136"
                  >
                    Node
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      <div className="copyright py-4 bg-footer">
        <div className="container">
          <div className="row">
            <div className="col-sm-7 text-sm-left text-center">
              <p className="mb-0">
                Copyright &copy;
                <script>
                  var CurrentYear = new Date().getFullYear()
                  document.write(CurrentYear)
                </script>
                , designed & developed by{" "}
                <a
                  href="https://www.upwork.com/freelancers/haroonrasheed136"
                  rel="noreferrer"
                  target="_blank"
                  className="text-muted"
                >
                  Web Weavers
                </a>
              </p>
            </div>
            <div className="col-sm-5 text-sm-right text-center">
              <ul className="list-inline">
                <li className="list-inline-item">
                  <a
                    className="d-inline-block p-2"
                    href="https://web.facebook.com/jamshaid.haidermalik"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <i className="ti ti-facebook text-primary"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="d-inline-block p-2"
                    href="https://www.linkedin.com/in/jamshaid-haider-malik-047514141/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <i className="ti ti-linkedin text-primary"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="d-inline-block p-2"
                    rel="noreferrer"
                    target="_blank"
                    href="https://github.com/haroonh128"
                  >
                    <i className="ti ti-github text-primary"></i>
                  </a>
                </li>
                <li className="list-inline-item">
                  <a
                    className="d-inline-block p-2"
                    rel="noreferrer"
                    target="_blank"
                    href="https://www.instagram.com/jamshaid.h.malik/"
                  >
                    <i className="ti ti-instagram text-primary"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
